<p>There was an error while signing in.</p>
<!-- <div class="button-strip">
    <citadel-button (click)="goBack()" >Cancel</citadel-button>&nbsp;
    <citadel-button [primary]="true" [isSubmit]="true" (click)="signOut()" >Sign Out</citadel-button>
</div> -->
